module.exports = __webpack_public_path__ + "static/media/power.bcb67f5f.svg";